import Cookies from "js-cookie";

const TokenKey = "Admin-Token";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getRole() {
  let role = Cookies.get("arole");
  if (!role || role == "undefined") return {};
  return JSON.parse(role);
}

export function setRole(role) {
  return Cookies.set("arole", role);
}

export function removeRole() {
  return Cookies.remove("arole");
}

export function getRule() {
  let rules = Cookies.get("arule");
  if (!rules || rules == "undefined") return {};
  return JSON.parse(Cookies.get("arule"));
}

export function setRule(rule) {
  return Cookies.set("arule", rule);
}

export function removeRule() {
  return Cookies.remove("arule");
}
